import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { NoDataFoundImage } from "../../assets/Icon/NodataImage";
import theme from "../../theme";
import CustomButton from "./CustomButton";

interface nodataPropsTypes {
  title?: string;
  subTitle?: string;
  breakWords?: string[]; 
  showImage?:boolean | true;
  showButton?:boolean | false;
  handleApplyNow?:() => void;
}
const NoOrdersFound = (props: nodataPropsTypes) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { title, subTitle, breakWords = [],showImage, showButton, handleApplyNow } = props;

 
  const formattedSubTitle = subTitle
    ? breakWords.reduce((acc, word) => acc.replace(new RegExp(`\\b${word}\\b`), `\n${word}`), subTitle)
    : "";

  return (
    <Box
      sx={{
        background: "transparent",
        paddingY: 6,
        textAlign: "center",
      }}
     >
     {showImage !== false && <NoDataFoundImage />}
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "28px",
          lineHeight: "46px",
          color: "#05000B",
  
         
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "28px",
          color: "#6C6F71",
          paddingBottom: 2,
         
          whiteSpace: "pre-line", 
        }}
      >
        {formattedSubTitle}
      </Typography>
      {showButton && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 ,width: isMobile ? "100%" : "auto"}}>
          <CustomButton btnTitle="Apply Now" handleClick={handleApplyNow} />
        </Box>
      )}
    </Box>
  );
};

export default NoOrdersFound;
